import React from 'react';

import {Box, Button, Typography} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

export default function MessageBox({ type, Icon, message, subMessage, handleReload, loadingSize }) {
    return (
        <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            {/* type === 'LOADING' 인 경우, 로딩바 렌더링 */}
            {type === 'LOADING' && <CircularProgress size={loadingSize} /> }
            
            {/* type !== 'LOADING' 인 경우, Icon, message, subMessage(혹은 재시도) 렌더링 */}
            {Icon && <Icon sx={{ width: '35px', height: '35px', color: type === 'ERROR' ? 'error.main' : 'primary.main' }} />}
            <Typography variant='body2' sx={{ marginTop: '8px', marginBottom: '4px' }}> {/* 디자인은 body1인테 크기가 맞지 않아 body2로 임시 설정 */}
                {message}
            </Typography>
            {type === 'ERROR'
                ? <Button
                    size='small'
                    color='error'
                    variant='text'
                    startIcon={<RefreshRoundedIcon />}
                    onClick={handleReload}
                >
                    재시도
                </Button> 
                : <Typography variant='subtitle3'>{subMessage}</Typography>
            }
        </Box>
    );
}
